import { subscribeToSubsite as apiSubscribeToSubsite } from 'api/cms';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Dispatch, ThunkAction } from '..';

type AddSubscribedSubsiteAction = {
  type: 'ADD_SUBSCRIBED_SUBSITE';
  subsiteId: string;
};
export type Action = AddSubscribedSubsiteAction;
export const addSubscribedSubsite =
  (subsiteId: string) => (dispatch: Dispatch) =>
    dispatch({
      type: 'ADD_SUBSCRIBED_SUBSITE',
      subsiteId,
    });
export const subscribeToSubsite =
  (subsiteId: string): ThunkAction =>
  (dispatch: Dispatch) =>
    apiSubscribeToSubsite(subsiteId).then(() => {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      dispatch<any>(addSubscribedSubsite(subsiteId));
    });
